import { httpClient } from "@/services";

export default {
	state: {
		settingsInventory: [],
		inventoryInventory: [],
		filtersInventory: {},
		editInventory: {},
	},
	mutations: {
		updateInventory(state, { settings, items, filters }) {
			state.settingsInventory = settings;
			state.inventoryInventory = items;
			state.filtersInventory = filters;
		},
		updateEditInventory(state, { department }) {
			state.editInventory = department;
		},
	},
	actions: {

		async deleteAccountInventory({ dispatch }, id) {
			try {
				const { data } = await httpClient.delete(`/info/inventory/${ id }`);
				if (data && data.status) {
					dispatch('getAccountInventoryList', true);
				}
			} catch (e) {
				console.error(e);
			}
		},

		async getAccountInventoryList({ commit, dispatch }) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get("/info/inventory");
				if (data) {
					commit('updateInventory', data);
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},

		async onAccountInventoryEdit({ commit, dispatch }, args ) {
			try {
				const { id, sendInfo } = args;
				const { data } = await httpClient.put(`/info/inventory/${ id }`, sendInfo);
				if ( data ) {
					commit('updateAccountSettings', data);
					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });

			} catch (e) {
				console.error(e);
			}
		},

		async onAccountInventorySave({ commit, dispatch }, args ) {
			// dispatch("actionPreloader", true);
			try {
				const { sendInfo } = args;

				const { data } = await httpClient.post("/info/inventory", sendInfo);

				if ( data ) {
					commit('updateAccountSettings', data);
					// dispatch("actionPreloader", false);
					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });

			} catch (e) {
				console.error(e);
			}
		},

		async getAccountInventoryEdit({ commit, dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get(`/info/inventory/${ id }/edit`);

				if (data && data.status) {
					commit('updateEditInventory', data);
					dispatch("actionPreloader", false);
					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });

			} catch (e) {
				console.error(e);
			}
		},
		// onDefaultList({ commit }) {
		// 	commit('updateDefaultList');
		// }
	},
	getters: {
		editInventory: s => s.editInventory,
		settingsInventory: s => s.settingsInventory,
		inventoryInventory: s => s.inventoryInventory,
		filtersInventory: s => s.filtersInventory,
	},
};
